module.exports = __webpack_public_path__ + "img/ic_main_menu_employee.0aca9051.png";